import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
var _this = this;
import React, { useState } from 'react';
import debounce from 'lodash/debounce';
import PropTypes from 'prop-types';
import useAppContext from 'flow/hooks/useAppContext';
import SearchInput from './ui-components/SearchInput';
import { jsx as _jsx } from "react/jsx-runtime";
var DEBOUNCE_WAIT_TIME_MS = 350;
var FilterSearchBar = function FilterSearchBar(_ref) {
  var handleFilter = _ref.handleFilter,
    _ref$searchText = _ref.searchText,
    searchText = _ref$searchText === void 0 ? '' : _ref$searchText,
    placeholder = _ref.placeholder;
  var _useAppContext = useAppContext(),
    i18next = _useAppContext.i18next;
  var _useState = useState(searchText),
    _useState2 = _slicedToArray(_useState, 2),
    filterText = _useState2[0],
    setFilterText = _useState2[1];
  var completeSearchDebounced = debounce(handleFilter.bind(_this), DEBOUNCE_WAIT_TIME_MS);
  var handleInputChange = function handleInputChange(event) {
    setFilterText(event.target.value);
    completeSearchDebounced(event, event.target.value);
  };
  return /*#__PURE__*/_jsx(SearchInput, {
    iconKey: "search",
    placeholder: placeholder ? placeholder : i18next.t('input.search'),
    onChange: handleInputChange,
    value: filterText,
    className: "dark:bg-gray-300"
  });
};
FilterSearchBar.propTypes = {
  handleFilter: PropTypes.func.isRequired,
  searchText: PropTypes.string,
  placeholder: PropTypes.string
};
export default FilterSearchBar;